import { useRef } from "react";
import classNames from "classnames";
import "./ChoiceButton.scss";
import { v4 as uuidv4 } from "uuid";
import PropTypes from "prop-types";

export const ChoiceButton = ({
	type = "radio",
	name,
	id: idProp,
	value,
	label,
	selectedValues = [],
	onChange,
	disabled = false,
	className,
}) => {
	const generatedId = useRef(uuidv4());
	const id = idProp || `${name}--${value}--${generatedId.current}`;

	const checked = Array.isArray(selectedValues) && selectedValues.includes(value);

	const handleChange = e => {
		if (disabled) {
			return;
		}

		if (type === "radio") {
			if (onChange) {
				onChange([value]);
			}
			return;
		}

		// checkbox
		const current = Array.isArray(selectedValues) ? selectedValues : [];
		const next = e.target.checked
			? Array.from(new Set([...current, value]))
			: current.filter(v => v !== value);

		if (onChange) {
			onChange(next);
		}
	};

	return (
		<div
			className={classNames(
				"choice-button",
				{ "choice-button--checked": checked, "choice-button--disabled": disabled },
				className
			)}
		>
			<input
				id={id}
				className="choice-button__input"
				type={type}
				name={name}
				value={value}
				checked={checked}
				disabled={disabled}
				onChange={handleChange}
			/>

			<label
				htmlFor={id}
				className={classNames("choice-button__label", {
					"choice-button__label--checked": checked,
					"choice-button__label--disabled": disabled,
				})}
			>
				{label}
			</label>
		</div>
	);
};

ChoiceButton.propTypes = {
	type: PropTypes.oneOf(["radio", "checkbox"]),
	name: PropTypes.string.isRequired,
	id: PropTypes.string,
	value: PropTypes.string.isRequired,
	label: PropTypes.node.isRequired,
	selectedValues: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	className: PropTypes.string,
};
